
import React from 'react';

interface NewsArticleProps {
  articleUrl: string;
  articleTitle: string;
}

const NewsArticle = ({ articleUrl, articleTitle }: NewsArticleProps) => {
  return (
    <li>
      <a 
        href={articleUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="text-brand-grey hover:text-brand-blue transition-colors line-clamp-2"
      >
        {articleTitle}
      </a>
    </li>
  );
};

export default NewsArticle;
